import React from 'react';
import { useScrollReveal } from './hooks/useScrollReveal';
import { useMetaPixel } from './hooks/useMetaPixel';
import { AnnouncementBar } from './components/layout/AnnouncementBar';
import { StickyNav } from './components/layout/StickyNav';
import { FloatingCta } from './components/layout/FloatingCta';
import { Footer } from './components/layout/Footer';
import { HeroSection } from './components/sections/HeroSection';
import { ProblemSection } from './components/sections/ProblemSection';
import { SolutionSection } from './components/sections/SolutionSection';
import { HowItWorksSection } from './components/sections/HowItWorksSection';
import { BeforeAfterSection } from './components/sections/BeforeAfterSection';
import { LearnSection } from './components/sections/LearnSection';
import { OfferSection } from './components/sections/OfferSection';
import { BonusesSection } from './components/sections/BonusesSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { CreatorSection } from './components/sections/CreatorSection';
import { GuaranteeSection } from './components/sections/GuaranteeSection';
import { FaqSection } from './components/sections/FaqSection';
import { FinalCtaSection } from './components/sections/FinalCtaSection';
export function App() {
  useScrollReveal();
  useMetaPixel();
  return <div className="min-h-screen bg-primary text-text-light font-sans selection:bg-accent/30 selection:text-white" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <StickyNav data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <HowItWorksSection data-id="element-7" />
        <LearnSection data-id="element-8" />
        <BeforeAfterSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <OfferSection data-id="element-11" />
        <BonusesSection data-id="element-12" />
        <CreatorSection data-id="element-13" />
        <GuaranteeSection data-id="element-14" />
        <FaqSection data-id="element-15" />
        <FinalCtaSection data-id="element-16" />
      </main>

      <Footer data-id="element-17" />
      <FloatingCta data-id="element-18" />
    </div>;
}